import { xhr } from '@/api/config/Repository'
import PenaltyManagementRepository from '../PenaltyManagementRepository'
import TablePenaltyRequest from '@/services/penaltyManagement/models/TablePenaltyRequest'
import PenaltyManagementResponseDTO from '../dto/PenaltyManagementResponseDTO'
import PenaltyManagementResponse from '@/services/penaltyManagement/models/PenaltyManagementResponse'
import AgreementNotesResponse from '@/services/penaltyManagement/models/AgreementNotesResponse'
import SaveAgreementNotesRequest from '@/services/penaltyManagement/models/SaveAgreementNotesRequest'
import SaveAgreementNotesResponseDTO from '../dto/SaveAgreementNotesResponseDTO'
import PenaltyDetailsRequest from '@/services/penaltyManagement/models/PenaltyDetailsRequest'
import TableExportResponse from '@/services/penaltyManagement/models/TableExportResponse'
import AgreementNotesResponseDTO from '../dto/AgreementNotesResponseDTO'
import TableAgreementNoteExportRequest from '@/services/penaltyManagement/models/TableAgreementNoteExportRequest'
export default class PenaltyManagementRepositoryImpl implements PenaltyManagementRepository {
  async getSearchPenaltyData (paramData: TablePenaltyRequest, penaltyType: string): Promise<PenaltyManagementResponse> {
    const reqBody: TablePenaltyRequest = {
      pageNumber: paramData.pageNumber,
      pageSize: paramData.pageSize,
      sortBy: paramData.sortBy,
      country: paramData.country,
      supplier: paramData.supplier,
      agreementNoteId: paramData.agreementNoteId,
      description: paramData.description,
      comments: paramData.comments,
      startCreationDate: paramData.startCreationDate,
      endCreationDate: paramData.endCreationDate,
      agreementNoteAmount: paramData.agreementNoteAmount,
      isQF: paramData.isQF
    }
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/fetchLPAgreementSummary'
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/fetchSLPAgreementSummary'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyRequest, PenaltyManagementResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getAgreementNotesData (paramData: TablePenaltyRequest, penaltyType: string): Promise<AgreementNotesResponse> {
    const reqBody: TablePenaltyRequest = {
      country: paramData.country,
      supplier: paramData.supplier
    }
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/fetchEligiblePenaltyForAN'
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/fetchEligibleSLPPenaltyForAN'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyRequest, AgreementNotesResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data.data,
      status: response.status
    }
  }

  async saveAgreementNotesData (paramData: SaveAgreementNotesRequest, penaltyType: string): Promise<any> {
    const reqBody: SaveAgreementNotesRequest = {
      countryId: paramData.countryId,
      supplierId: paramData.supplierId,
      penaltyData: paramData.penaltyData,
      totalPenaltyAmount: paramData.totalPenaltyAmount,
      finalAmountNegotiated: paramData.finalAmountNegotiated,
      comments: paramData.comments
    }
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/saveAgreementNote'
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/saveAgreementNote'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<SaveAgreementNotesRequest, SaveAgreementNotesResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getPenaltyDetailsData (paramData: PenaltyDetailsRequest, penaltyType: string): Promise<any> {
    // View Agreement Notes Details
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/fetchLPAgreementDetail/' + paramData.AgreementNoteId
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/fetchSlpAgreementDetail/' + paramData.AgreementNoteId
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<PenaltyDetailsRequest>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getTableExportData (paramData: string, penaltyType: string): Promise<TableExportResponse> {
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/downloadNoteLP/' + paramData
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/downloadNoteSLP/' + paramData
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getAgreementNoteExportData (filterParam: TableAgreementNoteExportRequest, isQfFilter: boolean, penaltyType: string): Promise<PenaltyManagementResponse> {
    let endpoint
    if (penaltyType === 'LogisticPenalty' || penaltyType === null) {
      endpoint = 'lp/agreementNote/export'
    } else if (penaltyType === 'ServicePenalties') {
      endpoint = 'slp/agreementNote/export'
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<TablePenaltyRequest, any>(endpoint, filterParam, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
